<form action="" class="" id="search-by-size">
    <div class="container-select-tab-1 flex-column">
        <label for="surface">หน้ายาง</label>
        <mat-form-field appearance="outline">
            <mat-select [(value)]="selectedWidthSignal"
                (selectionChange)="changeSelectedDropdown(ESearchBlockPath.HEIGHT, { width: selectedWidthSignal() })"
                placeholder="กรุณาเลือก">
                <mat-option [value]="defaultOption">{{ defaultOption }}</mat-option>
                @for(list of widthListSignal(); track i; let i = $index) {
                <mat-option [value]="list.value">
                    {{ list.value }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <label for="surface">ซีรีส์ยาง</label>
        <mat-form-field appearance="outline">
            <mat-select [(value)]="selectedHeightSignal" (selectionChange)="
              changeSelectedDropdown(ESearchBlockPath.SIZE, { width: selectedWidthSignal(), height: selectedHeightSignal() })
            " placeholder="กรุณาเลือก"
                [disabled]="selectedWidthSignal() === 'กรุณาเลือก' || selectedWidthSignal() === ''">
                <mat-option [value]="defaultOption">{{ defaultOption }}</mat-option>
                @for(list of heightListSignal(); track i; let i = $index) {
                <mat-option [value]="list.value">
                    {{ list.value }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <label for="surface">ขนาดกะทะล้อ</label>
        <mat-form-field appearance="outline">
            <mat-select [(value)]="selectedSizeSignal" placeholder="กรุณาเลือก"
                [disabled]="selectedHeightSignal() === 'กรุณาเลือก' || selectedHeightSignal() === '' ">
                <mat-option [value]="defaultOption">{{ defaultOption }}</mat-option>
                @for(list of sizeListSignal(); track i; let i = $index) {
                <mat-option [value]="list.value">
                    {{ list.value }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
</form>

<div class="between-button">
    <button class="themeDetailButton2" mat-flat-button (click)="closeDialog()">ยกเลิก</button>
    <button class="themeCompareProductButton1" mat-flat-button (click)="onClickSearch()" [disabled]="
    selectedWidthSignal() === 'กรุณาเลือก' ||
    selectedWidthSignal() === '' ||
    selectedHeightSignal() === 'กรุณาเลือก' ||
    selectedHeightSignal() === '' ||
    selectedSizeSignal() === 'กรุณาเลือก' ||
    selectedSizeSignal() === ''
  ">
        <span class="xl-mr-l-1">ค้นหา</span>
    </button>
</div>